"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconHelpUi = function IconHelpUi(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2m0 2c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8m-2.085 6.759L9 9.157C9.763 8.52 11.06 8 12.216 8 14.021 8 15 9.004 15 10.161s-.864 1.78-1.996 2.339c-.432.216-.534.394-.546.674l-.013.33h-1.45l-.012-.406c-.038-1.132.267-1.373 1.157-1.844.674-.356.877-.585.877-.877 0-.305-.216-.585-.826-.585-.776 0-1.666.458-2.276.966m1.818 5.77c-.661 0-1.157-.495-1.157-1.169 0-.623.496-1.131 1.157-1.131.623 0 1.119.508 1.119 1.131 0 .674-.496 1.17-1.119 1.17",
    clipRule: "evenodd"
  })));
};

export { IconHelpUi, IconHelpUi as default };
